
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'academy-achievements-public-ui',
  currentProjectVersion: 'static-1.948',
  depVersions: {
  "academy-achievements-public-ui": "static-1.948",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.508",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8478",
  "hubspot-dlb": "static-2.1911",
  "react-dlb": "static-1.93",
  "academy-ai-assistant-lib": "static-1.1664",
  "academy-common-lib": "static-1.15383",
  "academy-navigation-lib": "static-1.2574",
  "analytics_js": "static-1.4507",
  "apollo-stack-hubspot": "static-3.94",
  "avatar-components": "static-1.2925",
  "classnames": "static-2.10",
  "data-fetching-client": "static-1.10081",
  "enviro": "static-4.455",
  "foundations-assets": "static-1.5327",
  "foundations-components": "static-1.8692",
  "foundations-theming": "static-1.4927",
  "graphql": "static-1.93",
  "hub-http": "static-1.6650",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11934",
  "I18n": "static-7.1700",
  "quartz": "static-1.7619",
  "quartz-config": "static-1.1397",
  "quartz-core": "static-1.6838",
  "quartz-routing": "static-1.1049",
  "quartz-tracking": "static-1.998",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17175",
  "rpc-client-utils": "static-1.5113",
  "signup-constants": "static-1.19877",
  "styled-components": "static-2.100",
  "trellis-ecosystem": "static-1.7800",
  "ui-addon-i18n": "static-1.11586",
  "UIComponents": "static-3.8880",
  "viral-links-lib": "static-1.7520",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3896",
  "quartz-webpack": "static-1.3843",
  "bend-plugin-quartz-routing": "static-1.697",
  "HeadJS": "static-2.817",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3589",
  "msw": "static-1.102",
  "msw-config": "static-1.25",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "ai-components-ui-library": "static-1.9959",
  "ai-rendering-library": "static-1.11342",
  "breeze-engine-core": "static-1.1333",
  "breeze-engine-chat-components": "static-1.1033",
  "breeze-engine-lib": "static-1.2055",
  "copilot-toolkit": "static-1.12088",
  "hs-lodash": "static-4.45",
  "magpie-lib": "static-1.5879",
  "navigation-components": "static-1.19099",
  "nest": "static-1.675",
  "pulse": "static-1.1083",
  "storybook-react": "static-1.44",
  "ts-schema": "static-1.4379",
  "zustand": "static-1.88",
  "academy-service-client": "static-1.4133",
  "croppie": "static-2.10",
  "cssUtils": "static-1.1062",
  "feedback-loader": "static-1.30008",
  "FileManagerCore": "static-1.40279",
  "FileManagerLib": "static-1.40420",
  "final-form": "static-1.82",
  "foundations-components-legacy": "static-1.1717",
  "foundations-theming-specialty": "static-1.2643",
  "hs-story-utils": "static-1.9866",
  "HubStyle": "static-2.12241",
  "icons": "static-2.700",
  "immer": "static-1.105",
  "markdown-it": "static-1.6",
  "navigation-messaging": "static-1.8426",
  "onboarding-tours": "static-1.17347",
  "PatternValidationJS": "static-1.3327",
  "quick-fetch": "static-1.4209",
  "react-utils": "static-2.5640",
  "SafeStorage": "static-1.4834",
  "sanitize-text": "static-1.8597",
  "sassPrefix": "static-1.330",
  "SharedI18nStrings": "static-1.187",
  "StyleGuideUI": "static-3.514",
  "ui-addon-react-router-dom": "static-1.9968",
  "ui-addon-video-player": "static-1.9065",
  "ui-fonts": "static-1.1196",
  "ui-images": "static-2.1270",
  "usage-tracker-container": "static-1.7753",
  "usage-tracker-core": "static-1.7613",
  "video-embed": "static-1.36865",
  "wootric-nps": "static-1.7281",
  "hub-http-janus": "static-1.903",
  "hub-http-shared-msw-handlers": "static-1.10846",
  "hubspotter-http": "static-1.4953",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4961",
  "floating-ui": "static-1.67",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.97",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.3009",
  "bend-plugin-foundations-theming": "static-1.3410",
  "foundations-theming-base": "static-1.3912",
  "stylex": "static-1.46",
  "hs-locale-management": "static-1.379",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4749",
  "jasmine-runner": "static-1.6891",
  "opentelemetry-fe-types": "static-1.230",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.601",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.605",
  "quartz-auth": "static-1.1294",
  "quartz-head": "static-1.1284",
  "quartz-i18n": "static-1.1294",
  "quartz-test": "static-1.1294",
  "trellis-components": "static-1.3028",
  "usage-tracker-session-replay": "static-1.5449",
  "csstype": "static-1.50",
  "web-vitals": "static-1.19",
  "bend-plugin-chirp-manifest": "static-1.523",
  "chirp-fetch": "static-1.2343",
  "marketplace-ui-apps-core": "static-1.19525",
  "marketplace-ui-common": "static-1.20993",
  "trellis-story-utils": "static-1.4942",
  "foundations-components-test-utils": "static-1.6175",
  "react-input-autosize": "static-2.17",
  "signup-ui-url-generator": "static-2.8498",
  "bender-build-tools": "static-1.3518",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23629",
  "ContentUtils": "static-1.69403",
  "customer-data-objects-ui-components": "static-1.13471",
  "sanitize": "static-1.4915",
  "breeze-onboarding-components": "static-1.1002",
  "customer-data-filters-ui": "static-1.41281",
  "customer-data-objects": "static-1.8135",
  "customer-data-reference-ui-components": "static-1.13608",
  "data-integrations-breeze": "static-1.240",
  "embedded-academy-lib": "static-1.15923",
  "ExportDialog": "static-6.10812",
  "global-styles-ai-lib": "static-1.435",
  "highcharts": "static-8.115",
  "highlight.js": "static-1.90",
  "marketplace-embed-ba": "static-1.847",
  "mermaid": "static-1.44",
  "reporting-action-components": "static-1.42322",
  "reporting-data": "static-1.69256",
  "reporting-snowflake": "static-1.57872",
  "reporting-ui-components": "static-2.66525",
  "reporting-visualizations": "static-1.61330",
  "trial-components-library": "static-1.14323",
  "ui-universal-auth": "static-1.9663",
  "trellis-theming": "static-1.1431",
  "ui-addon-teams": "static-1.21977",
  "ui-addon-upgrades": "static-9.18528",
  "upgrade-components-lib": "static-1.682",
  "breeze-artifacts-sdk": "static-1.782",
  "ably": "static-2.2",
  "batch-promise": "static-1.1988",
  "superstore": "static-1.5199",
  "magpie-types": "static-1.5339",
  "simple-logging-lib": "static-1.3493",
  "idb-keyval": "static-1.55",
  "reactive-lib": "static-1.1164",
  "bend-plugin-pulse": "static-1.586",
  "event-emitter": "static-1.1401",
  "fast-json-patch": "static-1.74",
  "nudge-client-utils": "static-1.3361",
  "audio-components": "static-1.6521",
  "cropperjs": "static-1.10",
  "file-manager-components": "static-1.24780",
  "FileManagerImages": "static-1.37931",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4582",
  "react-colorpicker": "static-2.10652",
  "redux-toolkit": "static-1.82",
  "reselect": "static-3.16",
  "salesImages": "static-1.697",
  "urlinator": "static-1.4956",
  "usage-tracker": "static-1.7763",
  "video-components": "static-1.14375",
  "video-data-lib": "static-1.36031",
  "redux-thunk": "static-2.84",
  "nav-meta": "static-1.30736",
  "getting-started-shared-tasks": "static-1.19504",
  "growth-data-modal": "static-1.6083",
  "growth-onboarding-confetti": "static-1.3502",
  "growth-onboarding-next-action-utils": "static-1.2927",
  "onboarding-tours-client": "static-1.5562",
  "onboarding-tours-utils": "static-1.1414",
  "ui-shepherd-react": "static-3.10717",
  "ui-shepherd-tracker": "static-1.8098",
  "user-context": "static-1.5494",
  "transmute": "static-2.97",
  "outpost": "static-1.4574",
  "stylex-utils": "static-1.169",
  "opentelemetry-web": "static-1.22",
  "beacon-keepalive-queue": "static-1.141",
  "hubspotter-http-shared-msw-handlers": "static-1.10844",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "amplitude-session-replay-browser": "static-1.60",
  "developer-experience-shared-components": "static-1.10980",
  "immutable-less": "static-1.5093",
  "marketplace-ui-client-types": "static-1.18400",
  "ui-addon-iframeable": "static-1.9517",
  "ui-addon-integrations-directory-panel": "static-2.8395",
  "ui-extensibility-client-types": "static-1.4357",
  "ai-settings-ui-library": "static-1.8531",
  "integrations-lib": "static-1.17334",
  "laboratory-lib": "static-3.7591",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1491",
  "cms-field-types": "static-1.5254",
  "content-icons-ui": "static-1.2425",
  "underscore": "static-1.8",
  "atom": "static-1.5518",
  "customer-data-ui-utilities": "static-1.10274",
  "property-translator": "static-1.5820",
  "reference-resolvers": "static-1.8621",
  "onboarding-journeys-lib": "static-1.1178",
  "onboarding-scopes": "static-1.6893",
  "conversations-skeleton-state": "static-1.7603",
  "crm-message-bus": "static-1.44034",
  "customer-data-filters-ui-msw-helpers": "static-1.23716",
  "customer-data-property-utils": "static-1.8488",
  "events-data-lib": "static-1.687",
  "FormUrlGenerator": "static-2.5157",
  "framework-builder-read-service-client": "static-1.4311",
  "hs-resources": "static-1.634",
  "inbound-db-meta-service-client": "static-1.3756",
  "inbound-db-properties-service-client": "static-1.4129",
  "multi-account-reference-resolvers": "static-1.1446",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers-lite": "static-1.8549",
  "reporting-datasets-permissions-lib": "static-1.14712",
  "segments-client-types": "static-1.12056",
  "marketplace-embed": "static-1.23144",
  "marketplace-ui-install": "static-1.979",
  "marketplace-ui-tracking": "static-1.15163",
  "content-assistance-lib": "static-1.8372",
  "dashboard-lib": "static-1.83221",
  "frontend-preferences-client": "static-1.8359",
  "hubspot-prosemirror": "static-1.19226",
  "hubspot-prosemirror-plugins": "static-1.19218",
  "prosemirror": "static-1.13",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "rich-text-lib": "static-1.20501",
  "share-with-third-party-component-lib": "static-1.9152",
  "ui-addon-draggable": "static-3.5188",
  "ui-asset-management-lib": "static-1.11544",
  "ui-business-units-lib": "static-1.9537",
  "persist-promise": "static-1.4145",
  "reporting-client-types": "static-1.2805",
  "growth-payments-core": "static-1.26441",
  "hubspot-apollo-client": "static-1.5320",
  "reporting-plugins": "static-1.10925",
  "reporting-reports": "static-1.68932",
  "hs-promise-utils": "static-1.6033",
  "hubs-service-types": "static-1.1706",
  "merchandise-lib": "static-1.283",
  "purchase-motions-api": "static-1.6593",
  "purchase-motions-components": "static-1.6590",
  "unified-auth-core-lib": "static-1.1459",
  "nudge-custom-function-registry": "static-1.3118",
  "nudge-renderer-utils": "static-1.3437",
  "whisper-core-api": "static-1.7582",
  "apollo-link-hub-http": "static-2.5028",
  "poll-commands": "static-1.3916",
  "video-components-external": "static-1.12373",
  "social-insights-client-types": "static-1.22876",
  "onboarding-data-sync-lib": "static-1.2788",
  "growth-onboarding-next-action-components": "static-1.2955",
  "user-context-client": "static-1.4950",
  "getting-started-shared-tasks-store": "static-1.18622",
  "apps-service-types": "static-1.4087",
  "oauth-service-types": "static-1.4597",
  "settings-ui-lib": "static-1.12970",
  "simple-data-table": "static-1.3768",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14749",
  "integrations-tracking-lib": "static-1.6056",
  "native-integrations-shared-strings": "static-1.8204",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10811",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1177",
  "react-dnd-compat": "static-1.5051",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1963",
  "conditional-properties-service-client": "static-1.4098",
  "crm-pipelines-api-client-types": "static-1.4429",
  "fdsr-migration-layer": "static-1.454",
  "multi-currency-client-types": "static-1.3994",
  "external-options-client-types": "static-1.4427",
  "crm-index-associations-lib": "static-1.6890",
  "connections-embed-lib": "static-1.1692",
  "fail-safe": "static-1.389",
  "ai-studio-lib": "static-1.12700",
  "integrations-reconnect-lib": "static-1.665",
  "ui-product-approvals": "static-1.29596",
  "ui-tool-access": "static-1.10598",
  "ui-coaching-tips": "static-1.29542",
  "redux-actions": "static-3.74",
  "content-media-capture": "static-1.5726",
  "emoji-mart": "static-3.6",
  "knowledge-content-types": "static-1.8728",
  "payment-link-components": "static-1.24382",
  "ui-addon-emoji-picker": "static-1.10306",
  "EmailSignatureEditor": "static-1.25191",
  "data-token-picker": "static-1.17078",
  "react-flip-move": "static-1.82",
  "nested-table": "static-1.674",
  "seat-types-lib": "static-1.988",
  "timezone-utils": "static-2.5672",
  "ui-addon-opt": "static-4.8829",
  "hubspot-apollo-cache": "static-1.779",
  "campaign-roi-lib": "static-1.10720",
  "campaigns-utils-lib": "static-1.3678",
  "ui-addon-calendars": "static-2.5803",
  "fsm": "static-1.4199",
  "content-media-composition-data-lib": "static-1.13530",
  "content-media-compositions": "static-2.17537",
  "media-bridge-lib": "static-1.19590",
  "InboxConnectUtils": "static-4.15788",
  "meetings-connect-utils-lib": "static-1.8057",
  "universal-page-editor-lib": "static-1.3450",
  "adobe-sign-auth-lib": "static-1.707",
  "ads-unified-auth-lib": "static-1.1836",
  "custom-vendor-connection-lib": "static-1.227",
  "google-sheets-integration-lib": "static-1.1273",
  "microsoft-drive-auth-lib": "static-1.433",
  "slack-ui-library": "static-1.10839",
  "surveymonkey-integration-lib": "static-1.804",
  "bend-plugin-fail-safe": "static-1.340",
  "codemirror": "static-5.106",
  "property-management-iframe": "static-1.14394",
  "react-codemirror": "static-1.11081",
  "collaboration-sidebar": "static-1.58989",
  "trellis-ext-dnd": "static-1.489",
  "growth-onboarding-feedback-components": "static-1.7023",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4867",
  "commerce-tours-lib": "static-1.6812",
  "customer-data-properties": "static-1.52951",
  "growth-onboarding-reliability": "static-1.5522",
  "sales-checkout-service-client": "static-1.3965",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22304",
  "sales-email-signature-service-client": "static-1.4290",
  "ts-utils-lib": "static-1.590",
  "copilot-messaging": "static-1.2338",
  "js-cookie": "static-1.18",
  "hub-http-contrib": "static-1.3470",
  "ui-addon-sales-email": "static-1.5643",
  "crm-record-cards-service-types": "static-1.3851",
  "framework-data-schema-resolvers": "static-1.7335",
  "location-customization-utils-lib": "static-1.10360",
  "diff-match-patch": "static-1.7",
  "property-management-common": "static-1.6682",
  "browser-eslint": "static-2.57",
  "chatspot-widget-iframe": "static-1.23620",
  "collaboration-sidebar-common": "static-1.3786",
  "marketing-platform-lib": "static-1.7338",
  "dnd-kit": "static-1.20",
  "commerce-products-lib": "static-1.10822",
  "calling-global-api": "static-1.66088",
  "calling-internal-common": "static-1.31765",
  "calling-lifecycle-internal": "static-1.67470",
  "calling-lifecycle-messages": "static-1.59763",
  "crm-index-visualization-core": "static-1.4713",
  "crm-links": "static-1.6748",
  "customer-data-properties-shared-msw-handlers": "static-1.10173",
  "formula-editor": "static-1.14962",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4508",
  "meetings-icalendar-utils-lib": "static-1.1078",
  "object-builder-ui-client": "static-1.49977",
  "pipeline-validation-client-types": "static-1.4266",
  "property-value-citations": "static-1.3565",
  "smart-data-capture-core": "static-1.413",
  "smart-property-lib": "static-1.8571",
  "tiered-pricing": "static-1.2177",
  "topics-actions-lib": "static-1.619",
  "trellis-ext-i18n": "static-1.1333",
  "ui-addon-form-validation": "static-1.11342",
  "framework-data-schema-quick-fetch": "static-1.7240",
  "crm-component-utils": "static-1.40110",
  "crm-properties-common-lib": "static-1.6331",
  "commerce-permissions": "static-1.1223",
  "customer-data-tracking": "static-1.7313",
  "products-iframe-lib": "static-1.8842",
  "products-ui-components-shared-msw-handlers": "static-1.11228",
  "calling-error-reporting": "static-1.31772",
  "shared-worker-versioning": "static-1.11482",
  "calling-usage-tracker": "static-1.6975",
  "voice-sms-access-library": "static-1.2370",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10929",
  "sales-views-client-types": "static-1.4698",
  "bark-lib": "static-1.16972",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.850",
  "data-agent-test-utils": "static-1.394",
  "data-agent-utils": "static-1.863",
  "policy-lib": "static-1.7249",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10992",
  "commerce-subscription-lib": "static-1.38034",
  "crm-actions": "static-1.6793",
  "crm-cards-sdk": "static-1.44927",
  "trellis-migration-context": "static-1.19",
  "calling-orchestration-schema": "static-1.37147",
  "react-reducer-toolkit": "static-1.16611",
  "enrichment-settings-lib": "static-1.182",
  "commerce-billing-lib": "static-1.20473",
  "commerce-shared-components-lib": "static-1.19507",
  "commerce-tools-ui-lib": "static-1.11265",
  "crm_data": "static-4.93136",
  "crm-fe-perf": "static-1.23337",
  "universal-record-utils-lib": "static-1.2293",
  "utility-belt": "static-1.2977",
  "customer-data-associations": "static-1.7775",
  "framework-data-table": "static-2.12785",
  "payments-enrollment-embed-lib": "static-1.24137",
  "stripe-embedded-components": "static-1.8190",
  "customer-data-rte": "static-1.33843",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6479",
  "payments-post-enroll-local-storage-lib": "static-1.5543",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39123",
  "crm_universal": "static-1.22673",
  "customer-data-email": "static-1.18600",
  "crm-object-search-query-utilities": "static-1.10407",
  "tasks-actions-lib": "static-1.380",
  "stripe-connect-js": "static-1.82",
  "draft-content-plugins": "static-1.29100",
  "sequences-lib": "static-1.8720",
  "ui-gdpr-components": "static-1.10651",
  "sequences-client-types-lib": "static-1.8577"
},
  depPathPrefixes: {
  "academy-achievements-public-ui": "/academy-achievements-public-ui/static-1.948",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.508",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8478",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "react-dlb": "/react-dlb/static-1.93",
  "academy-ai-assistant-lib": "/academy-ai-assistant-lib/static-1.1664",
  "academy-common-lib": "/academy-common-lib/static-1.15383",
  "academy-navigation-lib": "/academy-navigation-lib/static-1.2574",
  "analytics_js": "/analytics_js/static-1.4507",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "avatar-components": "/avatar-components/static-1.2925",
  "classnames": "/classnames/static-2.10",
  "data-fetching-client": "/data-fetching-client/static-1.10081",
  "enviro": "/enviro/static-4.455",
  "foundations-assets": "/foundations-assets/static-1.5327",
  "foundations-components": "/foundations-components/static-1.8692",
  "foundations-theming": "/foundations-theming/static-1.4927",
  "graphql": "/graphql/static-1.93",
  "hub-http": "/hub-http/static-1.6650",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11934",
  "I18n": "/I18n/static-7.1700",
  "quartz": "/quartz/static-1.7619",
  "quartz-config": "/quartz-config/static-1.1397",
  "quartz-core": "/quartz-core/static-1.6838",
  "quartz-routing": "/quartz-routing/static-1.1049",
  "quartz-tracking": "/quartz-tracking/static-1.998",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17175",
  "rpc-client-utils": "/rpc-client-utils/static-1.5113",
  "signup-constants": "/signup-constants/static-1.19877",
  "styled-components": "/styled-components/static-2.100",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7800",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11586",
  "UIComponents": "/UIComponents/static-3.8880",
  "viral-links-lib": "/viral-links-lib/static-1.7520",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3896",
  "quartz-webpack": "/quartz-webpack/static-1.3843",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.697",
  "HeadJS": "/HeadJS/static-2.817",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3589",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.25",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9959",
  "ai-rendering-library": "/ai-rendering-library/static-1.11342",
  "breeze-engine-core": "/breeze-engine-core/static-1.1333",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1033",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2055",
  "copilot-toolkit": "/copilot-toolkit/static-1.12088",
  "hs-lodash": "/hs-lodash/static-4.45",
  "magpie-lib": "/magpie-lib/static-1.5879",
  "navigation-components": "/navigation-components/static-1.19099",
  "nest": "/nest/static-1.675",
  "pulse": "/pulse/static-1.1083",
  "storybook-react": "/storybook-react/static-1.44",
  "ts-schema": "/ts-schema/static-1.4379",
  "zustand": "/zustand/static-1.88",
  "academy-service-client": "/academy-service-client/static-1.4133",
  "croppie": "/croppie/static-2.10",
  "cssUtils": "/cssUtils/static-1.1062",
  "feedback-loader": "/feedback-loader/static-1.30008",
  "FileManagerCore": "/FileManagerCore/static-1.40279",
  "FileManagerLib": "/FileManagerLib/static-1.40420",
  "final-form": "/final-form/static-1.82",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1717",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2643",
  "hs-story-utils": "/hs-story-utils/static-1.9866",
  "HubStyle": "/HubStyle/static-2.12241",
  "icons": "/icons/static-2.700",
  "immer": "/immer/static-1.105",
  "markdown-it": "/markdown-it/static-1.6",
  "navigation-messaging": "/navigation-messaging/static-1.8426",
  "onboarding-tours": "/onboarding-tours/static-1.17347",
  "PatternValidationJS": "/PatternValidationJS/static-1.3327",
  "quick-fetch": "/quick-fetch/static-1.4209",
  "react-utils": "/react-utils/static-2.5640",
  "SafeStorage": "/SafeStorage/static-1.4834",
  "sanitize-text": "/sanitize-text/static-1.8597",
  "sassPrefix": "/sassPrefix/static-1.330",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9968",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9065",
  "ui-fonts": "/ui-fonts/static-1.1196",
  "ui-images": "/ui-images/static-2.1270",
  "usage-tracker-container": "/usage-tracker-container/static-1.7753",
  "usage-tracker-core": "/usage-tracker-core/static-1.7613",
  "video-embed": "/video-embed/static-1.36865",
  "wootric-nps": "/wootric-nps/static-1.7281",
  "hub-http-janus": "/hub-http-janus/static-1.903",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10846",
  "hubspotter-http": "/hubspotter-http/static-1.4953",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4961",
  "floating-ui": "/floating-ui/static-1.67",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.97",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.3009",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3410",
  "foundations-theming-base": "/foundations-theming-base/static-1.3912",
  "stylex": "/stylex/static-1.46",
  "hs-locale-management": "/hs-locale-management/static-1.379",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4749",
  "jasmine-runner": "/jasmine-runner/static-1.6891",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.230",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.601",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.605",
  "quartz-auth": "/quartz-auth/static-1.1294",
  "quartz-head": "/quartz-head/static-1.1284",
  "quartz-i18n": "/quartz-i18n/static-1.1294",
  "quartz-test": "/quartz-test/static-1.1294",
  "trellis-components": "/trellis-components/static-1.3028",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5449",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.19",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.523",
  "chirp-fetch": "/chirp-fetch/static-1.2343",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19525",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20993",
  "trellis-story-utils": "/trellis-story-utils/static-1.4942",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6175",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8498",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23629",
  "ContentUtils": "/ContentUtils/static-1.69403",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13471",
  "sanitize": "/sanitize/static-1.4915",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1002",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41281",
  "customer-data-objects": "/customer-data-objects/static-1.8135",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13608",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.240",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15923",
  "ExportDialog": "/ExportDialog/static-6.10812",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.435",
  "highcharts": "/highcharts/static-8.115",
  "highlight.js": "/highlight.js/static-1.90",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.847",
  "mermaid": "/mermaid/static-1.44",
  "reporting-action-components": "/reporting-action-components/static-1.42322",
  "reporting-data": "/reporting-data/static-1.69256",
  "reporting-snowflake": "/reporting-snowflake/static-1.57872",
  "reporting-ui-components": "/reporting-ui-components/static-2.66525",
  "reporting-visualizations": "/reporting-visualizations/static-1.61330",
  "trial-components-library": "/trial-components-library/static-1.14323",
  "ui-universal-auth": "/ui-universal-auth/static-1.9663",
  "trellis-theming": "/trellis-theming/static-1.1431",
  "ui-addon-teams": "/ui-addon-teams/static-1.21977",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18528",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.682",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.782",
  "ably": "/ably/static-2.2",
  "batch-promise": "/batch-promise/static-1.1988",
  "superstore": "/superstore/static-1.5199",
  "magpie-types": "/magpie-types/static-1.5339",
  "simple-logging-lib": "/simple-logging-lib/static-1.3493",
  "idb-keyval": "/idb-keyval/static-1.55",
  "reactive-lib": "/reactive-lib/static-1.1164",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.586",
  "event-emitter": "/event-emitter/static-1.1401",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "nudge-client-utils": "/nudge-client-utils/static-1.3361",
  "audio-components": "/audio-components/static-1.6521",
  "cropperjs": "/cropperjs/static-1.10",
  "file-manager-components": "/file-manager-components/static-1.24780",
  "FileManagerImages": "/FileManagerImages/static-1.37931",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4582",
  "react-colorpicker": "/react-colorpicker/static-2.10652",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "reselect": "/reselect/static-3.16",
  "salesImages": "/salesImages/static-1.697",
  "urlinator": "/urlinator/static-1.4956",
  "usage-tracker": "/usage-tracker/static-1.7763",
  "video-components": "/video-components/static-1.14375",
  "video-data-lib": "/video-data-lib/static-1.36031",
  "redux-thunk": "/redux-thunk/static-2.84",
  "nav-meta": "/nav-meta/static-1.30736",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19504",
  "growth-data-modal": "/growth-data-modal/static-1.6083",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3502",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2927",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5562",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1414",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10717",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8098",
  "user-context": "/user-context/static-1.5494",
  "transmute": "/transmute/static-2.97",
  "outpost": "/outpost/static-1.4574",
  "stylex-utils": "/stylex-utils/static-1.169",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.141",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10844",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10980",
  "immutable-less": "/immutable-less/static-1.5093",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18400",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9517",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8395",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4357",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8531",
  "integrations-lib": "/integrations-lib/static-1.17334",
  "laboratory-lib": "/laboratory-lib/static-3.7591",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1491",
  "cms-field-types": "/cms-field-types/static-1.5254",
  "content-icons-ui": "/content-icons-ui/static-1.2425",
  "underscore": "/underscore/static-1.8",
  "atom": "/atom/static-1.5518",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10274",
  "property-translator": "/property-translator/static-1.5820",
  "reference-resolvers": "/reference-resolvers/static-1.8621",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1178",
  "onboarding-scopes": "/onboarding-scopes/static-1.6893",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7603",
  "crm-message-bus": "/crm-message-bus/static-1.44034",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23716",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8488",
  "events-data-lib": "/events-data-lib/static-1.687",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5157",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4311",
  "hs-resources": "/hs-resources/static-1.634",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3756",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4129",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1446",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8549",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14712",
  "segments-client-types": "/segments-client-types/static-1.12056",
  "marketplace-embed": "/marketplace-embed/static-1.23144",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.979",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15163",
  "content-assistance-lib": "/content-assistance-lib/static-1.8372",
  "dashboard-lib": "/dashboard-lib/static-1.83221",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8359",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19226",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19218",
  "prosemirror": "/prosemirror/static-1.13",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "rich-text-lib": "/rich-text-lib/static-1.20501",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9152",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5188",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11544",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9537",
  "persist-promise": "/persist-promise/static-1.4145",
  "reporting-client-types": "/reporting-client-types/static-1.2805",
  "growth-payments-core": "/growth-payments-core/static-1.26441",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5320",
  "reporting-plugins": "/reporting-plugins/static-1.10925",
  "reporting-reports": "/reporting-reports/static-1.68932",
  "hs-promise-utils": "/hs-promise-utils/static-1.6033",
  "hubs-service-types": "/hubs-service-types/static-1.1706",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "purchase-motions-api": "/purchase-motions-api/static-1.6593",
  "purchase-motions-components": "/purchase-motions-components/static-1.6590",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1459",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3118",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3437",
  "whisper-core-api": "/whisper-core-api/static-1.7582",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5028",
  "poll-commands": "/poll-commands/static-1.3916",
  "video-components-external": "/video-components-external/static-1.12373",
  "social-insights-client-types": "/social-insights-client-types/static-1.22876",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2788",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2955",
  "user-context-client": "/user-context-client/static-1.4950",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18622",
  "apps-service-types": "/apps-service-types/static-1.4087",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "settings-ui-lib": "/settings-ui-lib/static-1.12970",
  "simple-data-table": "/simple-data-table/static-1.3768",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14749",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6056",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8204",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10811",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1177",
  "react-dnd-compat": "/react-dnd-compat/static-1.5051",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1963",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4098",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4429",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.454",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3994",
  "external-options-client-types": "/external-options-client-types/static-1.4427",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6890",
  "connections-embed-lib": "/connections-embed-lib/static-1.1692",
  "fail-safe": "/fail-safe/static-1.389",
  "ai-studio-lib": "/ai-studio-lib/static-1.12700",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.665",
  "ui-product-approvals": "/ui-product-approvals/static-1.29596",
  "ui-tool-access": "/ui-tool-access/static-1.10598",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29542",
  "redux-actions": "/redux-actions/static-3.74",
  "content-media-capture": "/content-media-capture/static-1.5726",
  "emoji-mart": "/emoji-mart/static-3.6",
  "knowledge-content-types": "/knowledge-content-types/static-1.8728",
  "payment-link-components": "/payment-link-components/static-1.24382",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10306",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25191",
  "data-token-picker": "/data-token-picker/static-1.17078",
  "react-flip-move": "/react-flip-move/static-1.82",
  "nested-table": "/nested-table/static-1.674",
  "seat-types-lib": "/seat-types-lib/static-1.988",
  "timezone-utils": "/timezone-utils/static-2.5672",
  "ui-addon-opt": "/ui-addon-opt/static-4.8829",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.779",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10720",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3678",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5803",
  "fsm": "/fsm/static-1.4199",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13530",
  "content-media-compositions": "/content-media-compositions/static-2.17537",
  "media-bridge-lib": "/media-bridge-lib/static-1.19590",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15788",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8057",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3450",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.707",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1836",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.227",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1273",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.433",
  "slack-ui-library": "/slack-ui-library/static-1.10839",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.804",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.340",
  "codemirror": "/codemirror/static-5.106",
  "property-management-iframe": "/property-management-iframe/static-1.14394",
  "react-codemirror": "/react-codemirror/static-1.11081",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58989",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.489",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7023",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4867",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6812",
  "customer-data-properties": "/customer-data-properties/static-1.52951",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5522",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3965",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22304",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4290",
  "ts-utils-lib": "/ts-utils-lib/static-1.590",
  "copilot-messaging": "/copilot-messaging/static-1.2338",
  "js-cookie": "/js-cookie/static-1.18",
  "hub-http-contrib": "/hub-http-contrib/static-1.3470",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5643",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3851",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7335",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10360",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "property-management-common": "/property-management-common/static-1.6682",
  "browser-eslint": "/browser-eslint/static-2.57",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23620",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3786",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7338",
  "dnd-kit": "/dnd-kit/static-1.20",
  "commerce-products-lib": "/commerce-products-lib/static-1.10822",
  "calling-global-api": "/calling-global-api/static-1.66088",
  "calling-internal-common": "/calling-internal-common/static-1.31765",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67470",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59763",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4713",
  "crm-links": "/crm-links/static-1.6748",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10173",
  "formula-editor": "/formula-editor/static-1.14962",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4508",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1078",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49977",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4266",
  "property-value-citations": "/property-value-citations/static-1.3565",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.413",
  "smart-property-lib": "/smart-property-lib/static-1.8571",
  "tiered-pricing": "/tiered-pricing/static-1.2177",
  "topics-actions-lib": "/topics-actions-lib/static-1.619",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1333",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11342",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7240",
  "crm-component-utils": "/crm-component-utils/static-1.40110",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6331",
  "commerce-permissions": "/commerce-permissions/static-1.1223",
  "customer-data-tracking": "/customer-data-tracking/static-1.7313",
  "products-iframe-lib": "/products-iframe-lib/static-1.8842",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11228",
  "calling-error-reporting": "/calling-error-reporting/static-1.31772",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11482",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6975",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2370",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10929",
  "sales-views-client-types": "/sales-views-client-types/static-1.4698",
  "bark-lib": "/bark-lib/static-1.16972",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.850",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.394",
  "data-agent-utils": "/data-agent-utils/static-1.863",
  "policy-lib": "/policy-lib/static-1.7249",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10992",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38034",
  "crm-actions": "/crm-actions/static-1.6793",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44927",
  "trellis-migration-context": "/trellis-migration-context/static-1.19",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37147",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16611",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.182",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20473",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19507",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11265",
  "crm_data": "/crm_data/static-4.93136",
  "crm-fe-perf": "/crm-fe-perf/static-1.23337",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2293",
  "utility-belt": "/utility-belt/static-1.2977",
  "customer-data-associations": "/customer-data-associations/static-1.7775",
  "framework-data-table": "/framework-data-table/static-2.12785",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24137",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8190",
  "customer-data-rte": "/customer-data-rte/static-1.33843",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6479",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5543",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39123",
  "crm_universal": "/crm_universal/static-1.22673",
  "customer-data-email": "/customer-data-email/static-1.18600",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10407",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.380",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "draft-content-plugins": "/draft-content-plugins/static-1.29100",
  "sequences-lib": "/sequences-lib/static-1.8720",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8577"
}
};
